import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { BeatLoader } from 'react-spinners';
import Datetime from 'react-datetime'
import { date_format } from '../../../../../server/constants';
import NotificationSystem from 'react-notification-system';
import { get } from '../../../../../server/actions'
import { showFile, _addNotification, _addNotificationError } from "../../../../../server/util";

class StudrosterReport extends Component {
    constructor() {
        super()
        this.state = {
            loading: false,
            startDate: moment().startOf('W'),
            endDate: moment().endOf('W'),
            rptMonth: moment(),
            byTeacher: false
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    studRosterDownloadReport = () => {
        let _self = this;
        this.setState({ loading: true })
        const schoolId = sessionStorage.getItem('SchoolId');
        const districtId = 0;
        const schoolYear = sessionStorage.getItem('schoolYearValue');
        const start = moment(this.state.startDate).format('YYYY-MM-DD');
        const end = moment(this.state.endDate).format('YYYY-MM-DD');
        let _url = `/reports/studentRoster/${districtId}/${schoolId}/${schoolYear}?startDate=${start}&endDate=${end}&byTeacher=${this.state.byTeacher}&access_token=`
        get(_url)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 417 || response.status === 422) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    throw Error(res.statusMessage);
                } else if (res.statusCode === 422) {
                    throw Error(res.statusMessage);
                } else {
                    return res.blob();
                }
            }).then(blob => {
                let filename = "Student Roster report";
                showFile(blob, filename);
                this.setState({ loading: false })
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    this.setState({ loading: false })
                }
            )
    }

    render() {
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="row">
                    <div className="panel-p1 panel-primary col-md-offset-3 col-md-6">
                        <div className="panel-heading text-center">
                            <h3 className="panel-title">Student Roster</h3>
                        </div>
                        <div className="panel panel-primary">
                            <div className="panel-body">
                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>Start Date</label>
                                    <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                        <Datetime ref='startCalendar' dateFormat={date_format()} timeFormat={false} closeOnSelect={true}
                                            value={this.state.startDate}
                                            onChange={(e) => {
                                                this.setState({ startDate: moment(e) })
                                                this.refs.endCalendar.closeCalendar()
                                            }} renderInput={this.renderInput} />
                                    </div>
                                </div>
                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>End Date</label>
                                    <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                        <Datetime ref='endCalendar' dateFormat={date_format()} timeFormat={false} closeOnSelect={true}
                                            value={this.state.endDate}
                                            onChange={(e) => {
                                                this.setState({ endDate: moment(e) })
                                                this.refs.endCalendar.closeCalendar()
                                            }} renderInput={this.renderInput} />
                                    </div>
                                </div>
                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <div className='row'>
                                        <div className='col-md-3'></div>
                                        <div className='col-md-9'>
                                            <label>
                                                <input type="checkbox" name="remember"
                                                    checked={this.state.byTeacher}
                                                    onChange={(e) => {
                                                        this.setState({ byTeacher: e.target.checked })

                                                    }} /> <span
                                                        className="label-text">Student Roster Report By Teacher</span>
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <button className="btn btn-success btn-sm" style={{ marginLeft: '37%' }} onClick={(e) => {
                                        e.preventDefault();
                                        this.studRosterDownloadReport();
                                    }}> Download Report
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default StudrosterReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/studrosterReport/studrosterReport.jsx